<div class="buttons-bar">
  <button mat-icon-button color="warn" class="negative-margin" mat-dialog-close matTooltip="{{ 'btn.close' | translate }}">
    <mat-icon>close</mat-icon>
  </button>
</div>
<h2 style="text-align: center">{{ "page.careplanEditor.duplication.title" | translate }} : {{ data.careplanInfo.description }}</h2>

<div *ngIf="isLoading" class="loading">
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</div>
<mat-dialog-content *ngIf="!isLoading">
  <form [formGroup]="form">
    <app-translation-form
      id="cpEditor-cpNameContainer"
      [formGroup]="descriptionForm"
      [translationsFormArray]="descriptionTradForm"
      [availableLangs]="availableLangs"
      [placeholder]="'page.careplanEditor.tabs.general.careplanName' | translate"
    ></app-translation-form>
    <h3 class="mt-1">{{ "forms.services" | translate }} *</h3>
    <!-- Above the list to be visible even if there are a lot of services -->
    <mat-error *ngIf="serviceForm.invalid && serviceForm.touched" class="services-error">
      {{ "page.careplanEditor.error.noService" | translate }}
    </mat-error>
    <div class="services-list" [class.services-list-invalid]="serviceForm.invalid && serviceForm.touched">
      <div *ngFor="let s of availableServices">
        <mat-checkbox [checked]="s.checked" (change)="healthcareServiceChange(s)">
          <p>{{ s.service.serviceName }} ({{ s.service.organizationName }})</p>
        </mat-checkbox>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!isLoading" align="end">
  <button mat-raised-button color="primary" (click)="confirm()">
    {{ "btn.validate" | translate }}
  </button>
</mat-dialog-actions>
